<template>
  <div>
    <BreadCrumb
      class="bread"
      :breads="['订单管理', '联合查询', title]"
    ></BreadCrumb>
    <div class="header">
      <span class="nameFt">{{ title }}</span>
      <el-button
        class="addCustom"
        size="small"
        icon="el-icon-arrow-left"
        @click="goBack"
        >返回列表</el-button
      >
    </div>
    <el-form
      :model="formData"
      size="small"
      label-width="120px"
      class="order-form"
    >
      <div class="order-status">
        <span class="order-status__label">订单状态</span>
        <span class="order-status__value" :class="statusClass">{{
          formData.status_value
        }}</span>
      </div>
      <div class="form-header">付款信息</div>
      <div class="form-container">
        <div class="form-container__left">
          <el-form-item label="订单编号" prop="order_no">
            <span>{{ formData.order_no }}</span>
          </el-form-item>
          <el-form-item label="创建时间" prop="created_at">
            <span>{{ formData.created_at | formatTimeBySecond }}</span>
          </el-form-item>
          <el-form-item label="付款时间" prop="payment_time">
            <span v-if="formData.payment_time">{{
              (formData.payment_time * 1000) | formatTimeBySecond
            }}</span>
          </el-form-item>
          <el-form-item label="开门时间" prop="t_open_door">
            <span>{{ formData.t_open_door }}</span>
          </el-form-item>
        </div>
        <div class="form-container__right">
          <el-form-item label="付款方式" prop="pay_channel">
            <span>{{ formData.pay_channel }}</span>
          </el-form-item>
          <el-form-item label="购买时长" prop="seconds">
            <span>{{ formData.seconds }}秒</span>
          </el-form-item>
          <el-form-item label="识别状态" prop="recognition_status">{{
            formData.recognition_status
          }}</el-form-item>
          <el-form-item label="关门时间" prop="t_close_door">
            <span>{{ formData.t_close_door | formatTimeBySecond }}</span>
          </el-form-item>
        </div>
      </div>
      <div class="form-header">设备信息</div>
      <div class="form-container">
        <div class="form-container__left">
          <el-form-item label="机器编号" prop="machine_id">
            <span>{{ formData.machine_id }}</span>
            <el-button
              @click="
                $router.push({
                  name: 'cabinetUpdate',
                  query: {
                    hard_number: formData.machine_id,
                    operateType: 'look',
                    redirect: 'order',
                  },
                })
              "
              style="margin-left: 12px"
              type="text"
              >陈列详情</el-button
            >
          </el-form-item>
          <el-form-item label="点位名称" prop="point_name">
            <span>{{ formData.point_name }}</span>
          </el-form-item>
        </div>
        <div class="form-container__right">
          <el-form-item label="线路名称" prop="line_name">
            <span>{{ formData.line_name }}</span>
          </el-form-item>
          <!-- <el-form-item label="柜号" prop="" v-if="formData.mode"></el-form-item> -->
        </div>
      </div>
      <div class="form-header">用户信息</div>
      <div class="form-container">
        <div class="form-container__left">
          <el-form-item label="用户手机" prop="phone">
            <span>{{ formData.phone }}</span>
            <el-button
              size="small"
              type="primary"
              style="margin-left: 20px"
              @click="block"
              >拉黑</el-button
            >
          <!-- <el-form-item label="拉黑:" prop="black_remarks" v-if="this.black_remarks">
            <span>{{this.black_remarks}}</span>
          </el-form-item> -->
            <el-button
              size="small"
              type="primary"
              style="margin-left: 20px"
              @click="remarks"
              >备注</el-button
            >
          </el-form-item>
          <el-form-item label="备注:" prop="remarks" v-if="this.remark">
            <span>{{ this.remark }}</span>
          </el-form-item>
          <el-form-item label="报错申请描述" v-if="formData.describe">
            <el-input
              type="textarea"
              maxlength="200"
              :disabled="true"
              v-model="formData.describe"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-container__right">
          <el-form-item label="报错分类" v-if="formData.status">
            <span class="bug-value">{{ formData.status }}</span>
          </el-form-item>
        </div>
      </div>
      <div class="form-header">支付信息</div>
      <div class="form-container">
        <div class="form-container__left">
          <el-form-item label="订单金额">
            <span>￥{{ formData.order_amount }}</span>
          </el-form-item>
          <el-form-item label="实付金额">
            <span style="color: #00cc00">￥{{ formData.pay_amount }}</span>
          </el-form-item>
          <el-form-item label="活动金额">
            <span style="color: #ff0000">￥{{ formData.discount_amount }}</span>
          </el-form-item>
          <span style="margin-left: 50px; font-size: 5%; color: red"
            >活动金额为负数表示需要额外收取，正数表示减免金额</span
          >
        </div>
        <div class="form-container__right">
          <el-form-item label="优惠券金额">
            <span>￥{{ formData.discount }}</span>
          </el-form-item>
          <el-form-item label="已退款金额">
            <span style="color: #ff0000">￥{{ formData.refund }}</span>
          </el-form-item>
        </div>
      </div>
      <div class="form-header">
        商品信息
        <span style="color: red; font-size: 80%" v-if="this.record !== ''"
          >识别结果:{{ record }}</span
        >
        <span
          style="color: red; font-size: 80%; margin-left: 20px"
          v-if="this.execution_result !== ''"
          >推送结果:{{ execution_result }}</span
        >
      </div>
      <div class="form-container">
        <el-table
          :data="tableData"
          @selection-change="selectChange"
          style="width: 100%"
        >
          <el-table-column prop="number" label="商品编号" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.number }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="real_price"
            label="单价（元）"
            width="112px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="qty"
            label="数量"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="order_price"
            label="金额"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </el-form>
    <div class="btnFroup">
      <el-button
        size="small"
        v-if=" formData.status_value == '待支付' && formData.order_no.startsWith('visionpay') "
        round
        @click="nfcforUse()"
        >nfc语音外呼</el-button
      >
      <el-button
      
        size="small"
        round
        @click="mainCamera()"
        >主摄像头</el-button
      >
      <el-button
       
        size="small"
        round
        @click="subCamera()"
        >副摄像头</el-button
      >
      <!-- <el-dropdown placement="top-start" class="dropBtn" @command="handleCommand" v-if="videoList.length && formData.order_no.indexOf('V') >= 0">
        <el-button type="primary" size="small" round>
          购物视频<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item,index) in videoList" :command="item" :key="index">{{videoName[index]}}摄像头</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <el-button
        v-if="formData.status_name == 'WAIT_PAY' && $route.query.type == 'look'"
        size="small"
        round
        @click="offlineCollection"
        >线下收款</el-button
      >
      <el-button
        size="small"
        v-if="formData.order_amount === 0"
        round
        @click="removeEmptyOrder"
        >清理空单</el-button
      >
      <!-- <el-button
        v-if="
          formData.status_name == 'WAIT_PAY' &&
          formData.pay_channel !== '微信' &&
          formData.pay_channel !== '微信代扣' &&
          $route.query.type == 'look'
        "
        size="small"
        round
        @click="receivables"
        >立即收款</el-button
      > -->
      <el-button
        v-if="formData.status_name == 'WAIT_PAY'"
        size="small"
        round
        @click="receivables"
        >立即收款</el-button
      >
      <el-button
        size="small"
        round
        @click="showReportOrderError"
        v-if="
          formData.status_name === 'TRADE_SUCCESS' ||
          formData.status_name == 'ORDER_CLOSE'
        "
        >订单报错</el-button
      >
      <el-button
        size="small"
        round
        @click="showSubsequentCollectionByGooods"
        v-if="Number(formData.order_amount) === 0"
        >补收商品</el-button
      >
      <el-button
        size="small"
        type="primary"
        round
        v-if="Number(formData.order_amount) === 0"
        @click="showSkuSubsequentCollectionByGooods"
        >无陈列商品补收</el-button
      >
      <el-button
        size="small"
        round
        @click="showWeightLog"
        v-if="
          formData.order_no.indexOf('G') >= 0 ||
          formData.gravity_assist === true
        "
        >重量变化</el-button
      >
      <el-button
        v-if="formData.status_name == 'WAIT_CHECK'"
        type="primary"
        size="small"
        round
        @click="openRefund"
        >退款处理</el-button
      >
      <el-button
        size="small"
        @click="openRefundDetail"
        v-if="
          ['TOTAL_REFUND', 'PARTIAL_REFUND', 'NO_REFUND'].indexOf(
            formData.status_name
          ) > -1
        "
        round
        >退款详情</el-button
      >
      <!-- <el-button
        v-if="formData.order_no.indexOf('G') === -1"
        size="small"
        type="primary"
        round
        class="form-item-btn"
        @click="openPicture"
        >查看图片</el-button
      > -->
      <el-button
        size="small"
        type="primary"
        round
        class="form-item-btn"
        @click="openVideoView"
        v-if="
          formData.order_no.indexOf('G') >= 0 &&
          Gvideo.length &&
          Gvideo[0].status != '待生成'
        "
        >查看视频</el-button
      >
      <el-button
        size="small"
        type="primary"
        round
        class="form-item-btn"
        @click="downVideo"
        v-if="
          formData.order_no.indexOf('G') >= 0 &&
          Gvideo.length &&
          Gvideo[0].status == '待生成'
        "
        >下载视频</el-button
      >
    </div>
    <!--查看照片-->
    <el-dialog
      title="查看照片"
      :visible.sync="pictureVisible"
      class="picture-dialog"
      :close-on-click-modal="false"
    >
      <el-tabs class="picture-tab">
        <el-tab-pane
          v-model="activeTab"
          v-for="(picture, index) in pictureList"
          :key="index"
          :name="index"
          :label="'第' + (index + 1) + '层'"
        >
          <div class="change-goods-con">
            <span>变化商品：</span>
            <span v-for="(value, name) in picture.add_item" :key="name"
              >{{ name }} +{{ value }}</span
            >
            <span v-for="(value, name) in picture.reduce_item" :key="name"
              >{{ name }} -{{ value }}</span
            >
            <span
              v-if="
                Object.keys(picture.add_item).length === 0 &&
                Object.keys(picture.reduce_item).length === 0
              "
              >无</span
            >
          </div>
          <div class="picture-box">
            <el-card class="picture-box-con">
              <div slot="header" class="picture-box-con-header">
                <span>识别前信息</span>
                <el-select
                  size="mini"
                  v-model="picture.tmp_result[0].recognition_status"
                >
                  <el-option
                    v-for="(status, key) in pictureEnum"
                    :value="key"
                    :key="key"
                    :label="status"
                  ></el-option>
                </el-select>
              </div>
              <div class="picture-box-con-img">
                <canvas
                  :id="'canvas' + picture.tmp_result[0].id"
                  width="1920"
                  height="1080"
                  style="width: 100%"
                  >您的浏览器不支持预览图片</canvas
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    openImageDialog(
                      picture.tmp_result[0].path,
                      picture.tmp_result[0].entry
                    )
                  "
                  >查看照片</el-button
                >
              </div>
            </el-card>
            <el-card class="picture-box-con">
              <div slot="header" class="picture-box-con-header">
                <span>识别后信息</span>
                <el-select
                  size="mini"
                  v-model="picture.tmp_result[1].recognition_status"
                >
                  <el-option
                    v-for="(status, key) in pictureEnum"
                    :value="key"
                    :key="key"
                    :label="status"
                  ></el-option>
                </el-select>
              </div>
              <div class="picture-box-con-img">
                <canvas
                  :id="'canvas' + picture.tmp_result[1].id"
                  width="1920"
                  height="1080"
                  style="width: 100%"
                  >您的浏览器不支持预览图片</canvas
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    openImageDialog(
                      picture.tmp_result[1].path,
                      picture.tmp_result[1].entry
                    )
                  "
                  >查看照片</el-button
                >
              </div>
            </el-card>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-button type="primary" @click="saveOrderImageStatus">提交</el-button>
    </el-dialog>
    <!--退款处理-->
    <el-dialog
      :title="refundDialogOperate == 'update' ? '退款处理' : '退款详情'"
      class="order-handle-dialog"
      :visible.sync="orderHandleVisible"
    >
      <div class="order-handle-dialog-title">原订单商品</div>
      <el-table
        border
        class="order-handle-dialog-table"
        size="small"
        :data="refundData.old_goodslist"
      >
        <el-table-column label="商品编号" prop="number"></el-table-column>
        <el-table-column label="商品名称" prop="name"></el-table-column>
        <el-table-column label="单价" prop="real_price"></el-table-column>
        <el-table-column label="数量" prop="qty"></el-table-column>
        <el-table-column label="金额" prop="order_price"></el-table-column>
      </el-table>
      <div class="order-handle-dialog-title">
        <span style="margin-right: 8px">处理后商品</span>
        <el-button
          size="mini"
          type="primary"
          @click="addOrderItem"
          v-if="refundDialogOperate == 'update'"
          >新增商品</el-button
        >
      </div>
      <el-table
        border
        class="order-handle-dialog-table"
        size="small"
        :data="refundData.new_goodslist"
      >
        <el-table-column label="商品编号" prop="number"></el-table-column>
        <el-table-column label="商品名称" prop="name"></el-table-column>
        <el-table-column label="单价(元)" prop="real_price">
          <div slot-scope="scope">
            <el-input
              v-model.number="scope.row.real_price"
              type="number"
              size="small"
              min="0"
              max="9999"
              v-if="refundDialogOperate == 'update'"
            ></el-input>
            <span v-else>{{ scope.row.real_price }}</span>
          </div>
        </el-table-column>
        <el-table-column label="数量" prop="qty">
          <div slot-scope="scope" prop="qty">
            <el-input
              v-model.number="scope.row.qty"
              type="number"
              size="small"
              min="1"
              max="99"
              v-if="refundDialogOperate == 'update'"
            ></el-input>
            <span v-else>{{ scope.row.qty }}</span>
          </div>
        </el-table-column>
        <el-table-column label="金额" prop="order_price">
          <div slot-scope="scope">
            <span v-if="scope.row.real_price && scope.row.qty">
              {{ Number(scope.row.real_price * scope.row.qty).toFixed(2) }}
            </span>
            <span v-else>0</span>
          </div>
        </el-table-column>
        <el-table-column label="操作" v-if="refundDialogOperate == 'update'">
          <div slot-scope="scope">
            <el-button
              size="mini"
              @click="replaceOrderItem(scope.$index)"
              type="primary"
              >选择</el-button
            >
            <el-button
              size="mini"
              @click="removeOrderItem(scope.$index)"
              type="danger"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <el-row
        class="order-handle-dialog-row"
        v-if="refundDialogOperate == 'read'"
      >
        <el-col :span="24">处理时间：{{ refundData.date }}</el-col>
      </el-row>
      <el-row class="order-handle-dialog-row">
        <el-col :span="8">
          订单金额：
          <span style="color: #ff0000">{{ oldOrderPriceSum }}</span
          >元
        </el-col>
        <el-col :span="8">
          处理后金额：
          <span style="color: #ff0000">{{ newOrderPriceSum }}</span
          >元
        </el-col>
        <el-col :span="8">
          {{ refundDialogOperate == "update" ? "应退款" : "已退款" }}：
          <span style="color: #ff0000">{{ refundPrice }}</span
          >元
        </el-col>
      </el-row>
      <el-row class="order-handle-dialog-row">
        <el-col :span="24">
          <el-input
            v-if="refundDialogOperate == 'update'"
            v-model="refundData.remark"
            placeholder="备注"
            maxlength="50"
            :readonly="refundDialogOperate == 'read'"
          ></el-input>
          <span v-else>备注：{{ refundData.remark }}</span>
        </el-col>
      </el-row>
      <el-row
        class="order-handle-dialog-row center"
        v-if="refundDialogOperate == 'update'"
      >
        <el-button type="primary" @click="refund">确定</el-button>
        <el-button type="warning" @click="refundAll">全额退款</el-button>
      </el-row>
    </el-dialog>
    <!--查看canvas大图-->
    <el-dialog
      :visible.sync="dialogImageVisible"
      width="1320px"
      :fullscreen="true"
      @open="setImage"
    >
      <div style="text-align: center">
        <canvas id="canvasDialog" width="1920" height="1080"
          >您的浏览器不支持预览图片</canvas
        >
      </div>
    </el-dialog>
    <!--选择商品-->
    <select-goods-dialog
      v-if="model"
      :show="selectGoodsVisible"
      @close="closeSelectGoodsDialog"
      :mode="formData.mode"
      :hard_number="formData.machine_id"
      :byPiece="formData.by_piece"
    ></select-goods-dialog>
    <!--补收商品选择商品弹窗-->
    <el-dialog
      title="选择补收商品"
      :visible.sync="selectSubsequentCollectionGoodsVisible"
      width="800px"
      :before-close="handleClose"
    >
      <div class="goods-search">
        <el-form size="small" :inline="true">
          <el-form-item>
            <el-input
              v-model="goodsName.good_name"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
          <el-button size="small" type="primary" @click="searchGoods"
            >查询</el-button
          >
          <el-button size="small" @click="restGoods">重置</el-button>
        </el-form>
      </div>
      <el-table
        :data="subsequentCollectionGoodList"
        size="small"
        @row-click="clickRow"
      >
        <el-table-column width="55" align="center">
          <template slot-scope="scope">
            <el-radio v-model="selectGoods" :label="scope.row">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          label="商品编号"
          prop="number"
          align="center"
        ></el-table-column>
        <el-table-column
          label="商品名称"
          prop="name"
          align="center"
        ></el-table-column>
        <el-table-column label="商品图片" align="center">
          <div slot-scope="scope">
            <img :src="scope.row.image_url" width="40px;" height="40px;" />
          </div>
        </el-table-column>
        <el-table-column
          label="金额"
          prop="real_price"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="goods-paging">
        <el-pagination
          @current-change="changeGoodsPage"
          :page-size="10"
          :current-page="itemsPaging.page_index"
          layout="total, prev, pager, next"
          :total="itemsPaging.total_count"
        ></el-pagination>
      </div>
      <div slot="footer" class="collection-goods-footer">
        <el-button type="primary" @click="closeSubsequentCollectionGooodsDialog"
          >确 定</el-button
        >
      </div>
    </el-dialog>
     <!--补收sku商品选择商品弹窗-->
     <el-dialog
      title="选择补收商品"
      :visible.sync="selectSkuSubsequentCollectionGoodsVisible"
      width="800px"
      :before-close="handleClose"
    >
      <div class="goods-search">
        <el-form size="small" :inline="true">
          <el-form-item>
            <el-input
              v-model="goodsName.good_name"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
          <el-button size="small" type="primary" @click="searchSkuGoods"
            >查询</el-button
          >
          <el-button size="small" @click="restSKUGoods">重置</el-button>
        </el-form>
      </div>
      <el-table
        :data="subSkusequentCollectionGoodList"
        size="small"
        @row-click="clickRow"
      >
        <el-table-column width="55" align="center">
          <template slot-scope="scope">
            <el-radio v-model="selectGoods" :label="scope.row">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          label="商品编号"
          prop="number"
          align="center"
        ></el-table-column>
        <el-table-column
          label="商品名称"
          prop="name"
          align="center"
        ></el-table-column>
        <el-table-column label="商品图片" align="center">
          <div slot-scope="scope">
            <img :src="scope.row.image_url" width="40px;" height="40px;" />
          </div>
        </el-table-column>
        <!-- <el-table-column
          label="金额"
          prop="total_count"
          align="center"
        ></el-table-column> -->
      </el-table>
      <div class="goods-paging">
        <el-pagination
          @current-change="changeSkuGoodsPage"
          :page-size="10"
          :current-page="itemsSKUPaging.page_index"
          layout="total, prev, pager, next"
          :total="itemsSKUPaging.total_count"
        ></el-pagination>
      </div>
      <div slot="footer" class="collection-goods-footer">
        <el-button type="primary" @click="closeSKUSubsequentCollectionGooodsDialog"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!--重力查看-->
    <el-dialog :visible.sync="weightLogVisible" title="重量变化">
      <div
        v-for="(log, index) in weightLogList.change"
        :key="index"
        style="margin-bottom: 8px"
      >
        第{{ log.row }}层重量变化值: {{ log.change }}g
      </div>
      <div>
        <p>操作日志：</p>
        <el-input
          style="margin-top: 12px"
          type="textarea"
          readonly
          v-model="weightLogList.weight"
          rows="5"
        ></el-input>
      </div>
    </el-dialog>
    <!--订单报错-->
    <el-dialog :visible.sync="orderReportErrorVisible" title="订单报错">
      <el-form
        ref="orderReportForm"
        :rules="orderReportRule"
        :model="reportErrorForm"
      >
        <el-form-item label="报错原因：">
          <el-radio
            v-for="(value, key) in reportErrorType"
            :label="key"
            :key="key"
            v-model="reportErrorForm.reportError"
            >{{ value }}</el-radio
          >
        </el-form-item>
        <el-form-item label="申请描述：" prop="reportErrorDesc">
          <el-input
            type="textarea"
            rows="4"
            v-model="reportErrorForm.reportErrorDesc"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="center-box">
        <el-button type="primary" @click="submitReportError">提交</el-button>
      </div>
    </el-dialog>
    <!--线下收款-->
    <!-- <el-dialog :visible.sync="offlineCollection" title="线下收款确认" center width="500px">
       <div style="text-align:center">请确定本次收款操作？</div>
        <span slot="footer" class="dialog-footer">
           <el-button @click="offlineCollection = false">取 消</el-button>
           <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
       </span>

    </el-dialog> -->
    <!-- 备注 -->
    <el-dialog :visible.sync="remarksVisible" title="备注" width="500px">
      <el-form>
        <el-form-item label="订单备注:" prop="remarks">
          <el-input
            type="textarea"
            :rows="6"
            v-model="formData.remarks"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="center-box">
        <el-button type="primary" @click="btnRemarks">确定</el-button>
      </div>
    </el-dialog>
    <!-- 拉黑 -->
    <el-dialog :visible.sync="blackVisible" title="拉黑" width="500px">
      <el-form>
        <el-form-item label="拉黑备注:" prop="black_remarks">
          <el-input
            type="textarea"
            :rows="6"
            v-model="formData.black_remarks"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="center-box">
        <el-button type="primary" @click="btnBlack">确定</el-button>
      </div>
    </el-dialog>
    <!--补收商品-->
    <el-dialog
      :visible.sync="subsequentCollectionByGooodsVisible"
      title="补收商品"
      @close="closeGoods"
    >
      <el-button
        size="small"
        type="primary"
        @click="selectSubsequentCollectionGoodsVisible = true"
        >增加商品</el-button
      >
      <el-table :data="subsequentCollectionGoods">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="商品编号" prop="number"></el-table-column>
        <el-table-column label="商品名称" prop="name"></el-table-column>
        <el-table-column label="单价(元)" prop="real_price"></el-table-column>
        <el-table-column label="金额(元)">
          <div slot-scope="scope">
            {{ (scope.row.num * scope.row.real_price).toFixed(2) }}
          </div>
        </el-table-column>
        <el-table-column label="数量">
          <div slot-scope="scope">
            <el-input-number
              size="mini"
              v-model="scope.row.num"
              :min="1"
            ></el-input-number>
          </div>
        </el-table-column>
        <el-table-column label="操作">
          <div slot-scope="scope">
            <el-button
              @click="removeSubsequentCollectionGooods(scope.$index)"
              type="danger"
              size="small"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <!-- <div style="margin-top: 20px">订单总金额：{{this.all_price}}</div> -->
      <div style="margin-top: 20px; color: red">
        订单总金额：{{ totalPrice }}元
      </div>
      <div class="center-box" style="margin-top: 20px">
        <el-button type="primary" @click="submitSubsequentCollectionByGooods"
          >确定</el-button
        >
      </div>
    </el-dialog>
      <!--补收sku商品-->
      <el-dialog
      :visible.sync="subSkusequentCollectionByGooodsVisible"
      title="补收sku商品"
      @close="closeSkuGoods"
    >
      <el-button
        size="small"
        type="primary"
        @click="selectSkuSubsequentCollectionGoodsVisible = true"
        >增加商品</el-button
      >
      <el-table :data="subSKUsequentCollectionGoods">
        <el-table-column type="index"></el-table-column>
            <el-table-column
          label="商品id"
          prop="number"
          align="center"
        ></el-table-column>
        <!-- <el-table-column label="商品id" prop="id"></el-table-column> -->
        <el-table-column label="商品图片" prop="number">
          <div slot-scope="scope" >
            <img :src="scope.row.image_url" width="40px;" height="40px;" /> 
          </div>
        </el-table-column>
        <el-table-column label="商品名称" prop="name"></el-table-column>
        <!-- <el-table-column label="单价(元)" prop="real_price"></el-table-column> -->
        <el-table-column label="金额(元)（仅供参考）" width="170px" >
          <div slot-scope="scope" >
            <el-input v-model="scope.row.real_price" type="number" :min="0" :step="0.01" size="small"></el-input>  
          </div>
        </el-table-column>
        <el-table-column label="数量" width="200px" align="center">
          <div slot-scope="scope">
            <el-input-number
              size="mini"
              v-model="scope.row.num"
              :min="1"
            ></el-input-number>
          </div>
        </el-table-column>
        <el-table-column label="操作">
          <div slot-scope="scope">
            <el-button
              @click="removeSKUSubsequentCollectionGooods(scope.$index)"
              type="danger"
              size="small"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <!-- <div style="margin-top: 20px">订单总金额：{{this.all_price}}</div> -->
      <div style="margin-top: 20px; color: red">
        订单总金额：{{ totalSKUPrice }}元
      </div>
      <div class="center-box" style="margin-top: 20px">
        <el-button type="primary" @click="submitSKUSubsequentCollectionByGooods"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="nfcVisible" width="300px">
      <el-form >
        <el-form-item label="手机号码"><el-input size="small" v-model="nfcmobile" width="200px"></el-input></el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="confirmNFC"
          >确定</el-button
        >
    </el-dialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import SelectGoodsDialog from "@/components/SelectGoodsDialog.vue";
import apis from "@/config/apis";
import { circleNumber } from "@/plugins/common";
import { deepClone } from "@/plugins/util";
import axiosInstance from "../../../config/axios";
import { reportErrorType } from "@/plugins/enum";
export default {
  name: "JointDetails",
  data() {
    var customNumert = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("扣款金额不能为空"));
      }
      if (value === "0") {
        return callback(new Error("扣款金额不能为0"));
      }
      if (!circleNumber(value)) {
        callback(new Error("请输入正确的数字"));
      }
      callback();
    };
    return {
      nfcVisible:false,
      nfcmobile:"",
      remark: "",
      remarksVisible: false,
      blackVisible: false,
      record: "",
      execution_result: "",
      formData: {
        order_no: "",
        cli_uid: "",
      },
      blockId: "",
      newArr: [],
      tableData: [],
      contractId: this.$route.query.order_id,
      itemidArr: [],
      imageArr: [],
      pictureVisible: false,
      orderHandleVisible: false,
      selectGoodsVisible: false,
      // offlineCollection:false,
      selectGoodsOperate: "add",
      replaceIndex: 0,
      timer: null,
      timeCount: 0,
      refundData: {
        old_goodslist: [],
        new_goodslist: [],
        remark: "",
      },
      refundDialogOperate: "update",
      activeTab: "0",
      pictureList: [],
      pictureEnum: {
        CORRECT: "正确",
        ERROR: "错误",
        LOW: "低信",
      },
      dialogImageVisible: false,
      dialogImageUrl: "",
      nodePath: "",
      nodeAxisList: [],
      weightLogVisible: false,
      weightActiveTab: "1",
      weightLogList: [],
      orderReportErrorVisible: false,
      reportErrorType: reportErrorType,
      reportErrorForm: {
        reportError: "RECOGNITIONERROR",
        reportErrorDesc: "",
      },
      selectGoods: {},
      subsequentCollectionByGooodsVisible: false,
      subsequentCollectionByGooodsData: {},
      selectSubsequentCollectionGoodsVisible: false,
      selectSkuSubsequentCollectionGoodsVisible: false,
      subSkusequentCollectionByGooodsVisible:false,
      subsequentCollectionGoods: [],
      subsequentCollectionGoodList: [],
      subSkusequentCollectionGoodList:[],
      subSKUsequentCollectionGoods:[],
      itemsPaging: {
        // good_name:""
      },
      itemsSKUPaging: {
        // good_name:""
      },
      goodsName: {
        good_name: "",
      },
      orderReportRule: {
        reportErrorDesc: {
          required: true,
          message: "请填写描述",
        },
      },
      videoList: [],
      videoName: ["主", "副"],
      Gvideo: [],
    };
  },
  computed: {
    title() {
      if (this.$route.query.operate === "look") {
        return "订单查看";
      } else {
        return "订单处理";
      }
    },
    statusClass() {
      if (this.formData.status_name === "WAIT_CHECK") {
        return "warning";
      } else if (this.formData.status_name === "WAIT_PAY") {
        return "error";
      }
      return "";
    },
    oldOrderPriceSum() {
      let _oldOrderPriceSumList = [];
      let _result = 0;
      if (this.refundData.old_goodslist.length > 0) {
        _oldOrderPriceSumList = this.refundData.old_goodslist.map((v) => {
          return v.real_price * v.qty;
        });
        _result = _oldOrderPriceSumList.reduce((total, i) => {
          return total + i;
        });
      }
      return _result.toFixed(2);
    },
    newOrderPriceSum() {
      let _newOrderPriceSumList = [];
      let _result = 0;
      if (this.refundData.new_goodslist.length > 0) {
        _newOrderPriceSumList = this.refundData.new_goodslist.map((v) => {
          return v.real_price * v.qty;
        });
        _result = _newOrderPriceSumList.reduce((total, i) => {
          return total + i;
        });
      }
      return _result.toFixed(2);
    },
    refundPrice() {
      let _result = Number(this.oldOrderPriceSum - this.newOrderPriceSum);
      return _result < 0 ? "0.00" : _result.toFixed(2);
    },
    totalPrice() {
      var totalPrice = 0;
      for (var i = 0; i < this.subsequentCollectionGoods.length; i++) {
        totalPrice +=
          this.subsequentCollectionGoods[i].real_price *
          this.subsequentCollectionGoods[i].num;
      }
      return totalPrice.toFixed(2);
    },
    totalSKUPrice() {
      var totalSKUPrice = 0;
      for (var i = 0; i < this.subSKUsequentCollectionGoods.length; i++) {
        totalSKUPrice +=
          this.subSKUsequentCollectionGoods[i].real_price *
          this.subSKUsequentCollectionGoods[i].num;
      }
      return totalSKUPrice.toFixed(2);
    },
  
  },
  created() {
    this.getData().then(() => {
      if (this.formData.order_no.indexOf("G") < 0) {
        this.getVideoList();
      } else {
        this.getVideo();
      }
      this.getSubsequentCollectionGoodList();
      this.getSkuSubsequentCollectionGoodList();
      if (
        ["TOTAL_REFUND", "PARTIAL_REFUND", "NO_REFUND"].indexOf(
          this.formData.status_name
        ) > -1
      ) {
        this.getRefundData();
      }
    });
  },
  methods: {
    getData() {
      return this.$axios
        .get(apis.order_detail + this.contractId)
        .then((res) => {
          // console.log(res);
          (this.record = res.data.data.record),
            (this.execution_result = res.data.data.execution_result);
          let { code, data } = res.data;
          if (code == 200) {
            this.tableData = data.goods_info;
            this.formData = Object.assign(
              data.order_error,
              data.payment,
              data.total_info,
              {
                refund: data.refund,
                t_close_door: data.t_close_door,
                t_open_door: data.t_open_door,
                remarks: data.remarks,
                // black_remarks: data.black_remarks,
              }
            );
            this.remark = this.formData.remarks 
            // this.black_remarks = this.formData.black_remarks 
            this.refundData.out_order_no = this.formData.order_no;
            this.blockId = this.formData.cli_uid;
            this.formData.mode = data.terminal_type;
            this.formData.gravity_assist = data.gravity_assist;
            data.terminal_type == "GR"
              ? (data.total_info.by_piece = "false")
              : (data.total_info.by_piece = "true");
            this.model = this.formData.mode;
            console.log("model", this.model);
          }
        });
    },
    // 拉黑
    block() {
      this.blackVisible = true
      // this.$axios.get(apis.pull_black + "/" + this.blockId).then((res) => {
      //   // console.log(res);
      //   if (res.data.msg === "拉黑成功") {
      //     this.$message({
      //       message: "拉黑成功",
      //       type: "success",
      //     });
      //   } else {
      //     this.$message({
      //       message: "拉黑失败",
      //       type: "error",
      //     });
      //   }
      // });
    },
    nfcforUse(){
      this.nfcVisible = true;
    },
    confirmNFC(){
      this.$axios.post(apis.nfc_merchant_call + "/" + this.formData.order_no+"/"+this.nfcmobile).then((res) => {

      })
    },
    btnBlack(){
      this.$axios.post(apis.pull_black + "/" + this.blockId,this.formData).then((res) => {
        console.log(res);
        if (res.status === 200) {
          this.$message({
            message:res.data.msg || "拉黑成功",
            type: "success",
          });
          this.getData();
        } else {
          this.$message({
            message: res.data.msg || "拉黑失败",
            type: "error",
          });
          this.getData();
        }
      });
     this.blackVisible = false
    },
    remarks() {
      this.remarksVisible = true;
    },
    btnRemarks() {
      this.$axios
        .post(
          apis.add_order_remarks + "/" + this.$route.query.order_id,
          this.formData
        )
        .then((res) => {
          if (res.status === 200) {
            this.$message({
              message: "备注成功",
              type: "success",
            });
            this.getData();
          } else {
            this.$message({
              message: "备注失败",
              type: "error",
            });
            this.getData();
          }
        });
      this.remarksVisible = false;
    },
    // 获取购物视频
    getVideoList() {
      this.$axios
        .get(`${apis.get_order_video}/${this.$route.query.order_id}`)
        .then((res) => {
          this.videoList = res.data.data.videos;
        });
    },
    // handleCommand(command) {
    //   console.log(command);
    //   window.open(command,'_blank')
    // },
    mainCamera() {
      this.getVideoList();
      window.open(this.videoList[0]);
    },
    subCamera() {
      this.getVideoList();
      window.open(this.videoList[1]);
    },
    // openPicture() {
    //   this.$axios
    //     .get(`${apis.order_get_imgs}${this.$route.query.order_id}`)
    //     .then((res) => {
    //       this.pictureVisible = true;
    //       this.pictureList = res.data.data;
    //     })
    //     .then(() => {
    //       this.pictureList.forEach((row) => {
    //         for (let r = 0; r < row.tmp_result.length; r++) {
    //           this.setCanvas(
    //             `canvas${row.tmp_result[r].id}`,
    //             row.tmp_result[r].path,
    //             row.tmp_result[r].entry
    //           );
    //         }
    //       });
    //     });
    // },
    // //线下收款
    // Offline(){
    //   this.offlineCollection = true;

    // },
    //将图片转化为canvas并赋值
    setCanvas(id, path, axisList) {
      let img = new Image();
      img.src = path;
      let _canvas = document.getElementById(id);
      let ctx = _canvas.getContext("2d");
      img.onload = () => {
        let barcodeList = [];
        let barcodeAverage = [];
        let averageValue = [];
        let colors = [
          "#DC143C",
          "#0000FF",
          "#00FF7F",
          "#FFD700",
          "#FF69B4",
          "#FF1493",
          "#C71585",
          "#DA70D6",
          "#9400D3",
          "#4B0082",
          "#7B68EE",
          "#1E90FF",
          "#FFFF00",
          "#FFA500",
          "#8B4513",
        ];
        ctx.drawImage(img, 0, 0, 1920, 1080);
        if (axisList) {
          //去重barcode数组并添加值到平均数组列表中
          for (let i = 0; i < axisList.length; i++) {
            if (barcodeList.indexOf(axisList[i].goods_name) < 0) {
              barcodeList.push(axisList[i].goods_name);
              averageValue.push([axisList[i].confidence]);
            } else {
              averageValue[barcodeList.indexOf(axisList[i].goods_name)].push(
                axisList[i].confidence
              );
            }
          }
          //计算平均值
          averageValue.forEach((item) => {
            const _item = item.reduce((acc, val) => acc + val, 0) / item.length;
            barcodeAverage.push(_item.toFixed(2) + "%");
          });
          barcodeList = Array.from(new Set(barcodeList));
          //实心矩形
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(20, 20, 200, 28 * barcodeList.length + 20);
          //输出文字
          for (let i = 0; i < barcodeList.length; i++) {
            ctx.font = "12px Arial";
            ctx.fillStyle = colors[i];
            ctx.fillText(
              barcodeList[i] + "    " + barcodeAverage[i],
              34,
              28 * (i + 1) + 20
            );
          }
          // 输出矩形
          for (
            let axiosIndex = 0, xmin = 0, ymin = 0, xmax = 0, ymax = 0;
            axiosIndex < axisList.length;
            axiosIndex++
          ) {
            xmin = axisList[axiosIndex].xmin;
            xmax = axisList[axiosIndex].xmax;
            ymin = axisList[axiosIndex].ymin;
            ymax = axisList[axiosIndex].ymax;
            let axisListname = axisList[axiosIndex].goods_name;
            ctx.lineWidth = "4";
            ctx.strokeStyle = colors[barcodeList.indexOf(axisListname)];
            //添加单个标注的框
            ctx.moveTo(xmin, ymin);
            ctx.lineTo(xmax, ymin);
            ctx.lineTo(xmax, ymax);
            ctx.lineTo(xmin, ymax);
            ctx.lineTo(xmin, ymin);
            ctx.stroke();
            //添加单个标注文字背景
            ctx.fillStyle = ctx.strokeStyle;
            ctx.fillRect(xmin - 2, ymin - 20, 30, 20);
            //添加单个标注的文字
            ctx.font = "12px Arial";
            ctx.fillStyle = "#FFFFFF";
            ctx.fillText(
              axisList[axiosIndex].confidence + "%",
              xmin + 2,
              ymin - 5
            );
            ctx.beginPath();
          }
        }
      };
    },
    //dialog打开后回调
    setImage() {
      let _that = this;
      setTimeout(function () {
        _that.setCanvas("canvasDialog", _that.nodePath, _that.nodeAxisList);
      }, 0);
    },
    //打开图片全屏
    openImageDialog(path, axisList) {
      this.dialogImageVisible = true;
      this.nodePath = path;
      this.nodeAxisList = axisList;
    },
    saveOrderImageStatus() {
      let _data = [];
      this.pictureList.forEach((item) => {
        for (let i = 0; i < item.tmp_result.length; i++) {
          _data.push({
            id: item.tmp_result[i].id,
            recognition_status: item.tmp_result[i].recognition_status,
          });
        }
      });
      this.$axios
        .post(apis.order_image_status, {
          order_id: this.$route.query.order_id,
          data: _data,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.pictureVisible = false;
          }
        });
    },
    getVideo() {
      this.$axios
        .post(apis.terminal_video, {
          mid: this.formData.machine_id,
          order_no: this.formData.order_no,
        })
        .then((res) => {
          this.Gvideo = res.data.data;
        });
    },
    downVideo() {
      this.$axios
        .get(apis.load_order_video, {
          params: {
            hard_number: this.formData.machine_id,
            order_no: this.formData.order_no,
          },
        })
        .then((res) => {
          this.$message.warning("视频生成中，请耐心等待");
          this.getVideo();
        });
    },
    openVideoView() {
      if (this.Gvideo[0].status == "生成中") {
        this.$message.warning("视频生成中，请耐心等待");
        this.getVideo();
        return;
      }
      window.open(this.Gvideo[0].path, "_blank");
    },
    goBack() {
      this.$router.back();

      // this.$router.push({
      //   name: this.$route.query.redirect
      //     ? this.$route.query.redirect
      //     : "OrderMangement",
      //   query: this.$route.params,
      // });
    },
    /*table 多选*/
    selectChange(selection) {
      this.itemidArr = selection;
    },
    validateRefundPrice(value) {
      if (value > this.formData.real_amount) {
        return false;
      } else {
        return true;
      }
    },
    openRefund() {
      this.refundDialogOperate = "update";
      this.orderHandleVisible = true;
      if (
        this.refundData.old_goodslist.length === 0 &&
        this.refundData.new_goodslist.length === 0
      ) {
        this.refundData.old_goodslist = deepClone(this.tableData);
        this.refundData.new_goodslist = deepClone(this.tableData);
      }
    },
    openRefundDetail() {
      this.refundDialogOperate = "read";
      this.orderHandleVisible = true;
      this.refundData.old_goodslist = deepClone(this.tableData);
    },
    receivables() {
      this.$confirm("请确定本次收款操作", "收款确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios.get(apis.order_receipt + this.contractId).then((res) => {
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "收款成功",
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      });
    },
    offlineCollection() {
      this.$confirm("线下收款确认", "请确定本次收款操作？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let jsonData = {
          orderid: this.formData.order_no,
        };
        this.$axios.post(apis.offline_pay, jsonData).then((res) => {
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "收款成功",
            });
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      });
    },
    //新增商品
    addOrderItem() {
      this.selectGoodsVisible = true;
      this.selectGoodsOperate = "add";
    },
    //替换商品
    replaceOrderItem(index) {
      this.selectGoodsVisible = true;
      this.replaceIndex = index;
      this.selectGoodsOperate = "replace";
    },
    //删除商品
    removeOrderItem(index) {
      this.refundData.new_goodslist.splice(index, 1);
    },
    //关闭选择商品
    closeSelectGoodsDialog(data) {
      if (data.id) {
        data.item_id = data.id;
        let _data = deepClone(data);
        _data.qty = 1;
        let isEmpty =
          this.refundData.new_goodslist.filter((item) => {
            return item.item_id === data.id || item.id === data.id;
          }).length === 0;
        if (isEmpty) {
          if (this.selectGoodsOperate === "add") {
            this.refundData.new_goodslist.push(_data);
          } else if (this.selectGoodsOperate === "replace") {
            this.refundData.new_goodslist.splice(this.replaceIndex, 1, _data);
          }
        } else {
          this.$message.error("已存在重复商品");
        }
      }
      this.selectGoodsVisible = false;
    },
    //退款
    refund() {
      this.refundData.new_goodslist = this.refundData.new_goodslist.filter(
        (item) => {
          return item.real_price != 0 && item.qty != 0;
        }
      );
      this.$axios.post(apis.refund, this.refundData).then((res) => {
        this.$router.push({
          name: "OrderMangement",
        });
      });
    },
    refundAll() {
      this.refundData.new_goodslist = [];
      this.refund();
    },
    //获取退款详情
    getRefundData() {
      this.$axios
        .get(apis.refund_order_items, {
          params: {
            order_id: this.formData.id,
          },
        })
        .then((res) => {
          let { date, data, remark } = res.data.data;
          this.refundData.new_goodslist = data;
          this.refundData.remark = remark;
          this.refundData.date = date;
        });
    },
    //清理空单
    removeEmptyOrder() {
      this.$confirm("此操作将删除该订单，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(`${apis.cancel_order}${this.formData.order_no}`)
            .then((res) => {
              if (res.data.code === 200) {
                this.$router.push({
                  name: "JointMangement",
                });
              } else {
                this.$message.error("清理失败");
              }
            });
        })
        .catch();
    },
    //重力变化
    showWeightLog() {
      this.$axios
        .get(`${apis.order_get_imgs}${this.$route.query.order_id}`)
        .then((res) => {
          // console.log(res);
          this.weightLogVisible = true;
          this.weightLogList = res.data.data;
        });
    },
    //报错
    showReportOrderError() {
      this.orderReportErrorVisible = true;
    },
    //提交报错
    submitReportError() {
      this.$refs.orderReportForm.validate((valid) => {
        if (valid) {
          this.$axios
            .post(apis.order_report_error, {
              oid: this.formData.order_no,
              error_type: this.reportErrorForm.reportError,
              describe: this.reportErrorForm.reportErrorDesc,
            })
            .then(() => {
              this.goBack();
            });
        }
      });
    },
    //获取补收商品
    getSubsequentCollectionGoodList() {
      this.$axios
        .get(
          `${apis.getSubsequentCollectionGoodList}/${this.formData.machine_id}`,
          {
            params: { ...this.itemsPaging, ...this.goodsName },
          }
        )
        .then((res) => {
          console.log(res);
          let { data, pagination } = res.data;
          this.subsequentCollectionGoodList = data;
          this.itemsPaging = pagination;
        });
    },
        //获取无陈列补收商品
        getSkuSubsequentCollectionGoodList() {
      this.$axios
        .get(
          `${apis.terminal_add_displays}/`,
          {
            params: { ...this.itemsSKUPaging, ...this.goodsName },
          }
        )
        .then((res) => {
          console.log(res,'res');
          let { data, pagination } = res.data;
          this.subSkusequentCollectionGoodList = data;
          this.itemsSKUPaging = pagination;
        });
    },
    clickRow(row) {
      this.selectGoods = row;
    },
    searchGoods() {
      this.itemsPaging.page_index = 1;
      this.getSubsequentCollectionGoodList();
    },
    searchSkuGoods() {
      this.itemsSKUPaging.page_index = 1;
      this.getSkuSubsequentCollectionGoodList();
    },
    restGoods() {
      this.goodsName.good_name = "";
      this.getSubsequentCollectionGoodList();
    },
    restSKUGoods() {
      this.goodsName.good_name = "";
      this.getSkuSubsequentCollectionGoodList();
    },
    //显示补收商品
    showSubsequentCollectionByGooods() {
         this.$axios
        .get(`${apis.get_order_video}/${this.$route.query.order_id}`)
        .then((res) => {
          this.subsequentCollectionGoods = res.data.data.da_1;
        });
      this.subsequentCollectionByGooodsVisible = true;
    },
      //显示sku补收商品
    showSkuSubsequentCollectionByGooods() {
         this.$axios
        .get(`${apis.get_order_video}/${this.$route.query.order_id}`)
        .then((res) => {
          // let _data =  res.data.data.da_1;
          let list = res.data.data.da_1 || [];

        list.forEach((data) => {
         const item = {
             id: data.item_id,
             barcode:data.barcode,
            //  gid:data.gid,
    // gid: String(data.number),
             number: data.number,
             name: data.name,
             real_price: data.real_price,
             num: data.num,
             image_url:  data.image_url,
   
              };

  this.subSKUsequentCollectionGoods.push(item);
});
            // this.subsequentCollectionGoods.map((item) => {
            // item.image_url = [
            //   {
            //    id:data.
            //   },
            // ];
          // _data.map((item,index)=>{
          //   iddata.gid
          // })

          //   let _data = {
          //   id: data.id,
          //   gid: String(data.number),
          //   number: data.number,
          //   name: data.name,
          //   real_price: data.real_price,
          //   num: 1,
          // };
          // this.subsequentCollectionGoods.push(_data);
          // this.subSKUsequentCollectionGoods = res.data.data.da_1;
        });
      this.subSkusequentCollectionByGooodsVisible = true;
    },
    
    //关闭弹层清空数据
    closeGoods() {
      this.subsequentCollectionGoods = [];
    },
        //关闭弹层清空数据
    closeSkuGoods() {
      this.subSKUsequentCollectionGoods = [];
    },
    changeGoodsPage(page_index) {
      this.itemsPaging.page_index = page_index;
      this.getSubsequentCollectionGoodList();
    },
    changeSkuGoodsPage(page_index) {
      this.itemsSKUPaging.page_index = page_index;
      this.getSkuSubsequentCollectionGoodList();
    },
    //关闭当前商品
    closeSubsequentCollectionGooodsDialog() {
      let data = this.selectGoods;
      this.selectSubsequentCollectionGoodsVisible = false;
      if (data.id) {
        let isExits = this.subsequentCollectionGoods.filter((item) => {
          return item.id === data.id;
        });
        if (!(isExits.length > 0)) {
          let _data = {
            id: data.id,
            gid: String(data.gid) == "undefined" ? String(data.number) : String(data.gid),
            number: data.number,
            name: data.name,
            real_price: data.real_price,
            num: 1,
          };
          this.subsequentCollectionGoods.push(_data);
          // let sum = 0
          // for (let i = 0; i <= this.subsequentCollectionGoods.length; i++) {
          //   let all = this.subsequentCollectionGoods[i].real_price
          //   sum += Number(all)
          //   this.all_price = sum
          // }
        }
      }
    },
       //关闭SKU当前商品
    closeSKUSubsequentCollectionGooodsDialog() {
      let data = this.selectGoods;
      this.selectSkuSubsequentCollectionGoodsVisible = false;
      if (data.id) {
        let isExits = this.subSKUsequentCollectionGoods.filter((item) => {
          return item.id === data.id;
        });
        if (!(isExits.length > 0)) {
          let _data = {
            id: data.id,
            name: data.name,
            number: data.number,
            barcode:data.barcode,
            real_price: data.real_price,
            image_url:data.image_url,
            // total_count: data.total_count,
            num: 1,
         
          };
          this.subSKUsequentCollectionGoods.push(_data);
          // let sum = 0
          // for (let i = 0; i <= this.subsequentCollectionGoods.length; i++) {
          //   let all = this.subsequentCollectionGoods[i].real_price
          //   sum += Number(all)
          //   this.all_price = sum
          // }
        }
      }
    },
    removeSubsequentCollectionGooods(index) {
      this.$confirm("确定删除此补收商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.subsequentCollectionGoods.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",           
            message: "已取消成功",
          });
        });
      // this.subsequentCollectionGoods.splice(index, 1);
    },
    removeSKUSubsequentCollectionGooods(index) {
      this.$confirm("确定删除此补收商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.subSKUsequentCollectionGoods.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消成功",
          });
        });
      // this.subsequentCollectionGoods.splice(index, 1);
    },

    //提交补收商品
    // submitSubsequentCollectionByGooods() {
    //   if(!this.subsequentCollectionGoods.length) {
    //     this.$message('您还未选择商品')
    //     return
    //   }
    //   this.$axios
    //     .post(apis.subsequentCollectionByGooods, {
    //       hard_number: this.formData.machine_id,
    //       order_token: this.formData.order_token,
    //       data: this.subsequentCollectionGoods,
    //       seconds: this.formData.seconds,
    //       coupe: this.formData.coupe, //左右门
    //     })
    //     .then(() => {
    //       this.goBack();
    //     });
    // },
    //提交补收商品
    submitSubsequentCollectionByGooods() {
      console.log( this.subsequentCollectionGoods,'')
      if (!this.subsequentCollectionGoods.length) {
        this.$message("您还未选择商品");
        return;
      }
      this.$confirm("确定此订单补收吗？点击确认后，会直接进行订单结算与扣款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(apis.subsequentCollectionByGooods, {
              hard_number: this.formData.machine_id,
              order_token: this.formData.order_token,
              data: this.subsequentCollectionGoods,
              seconds: this.formData.seconds,
              coupe: this.formData.coupe, //左右门
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消成功",
              });
            });
        })
        .then(() => {
          this.goBack();
        });
    },
       //提交SKU补收商品
       submitSKUSubsequentCollectionByGooods() {
        console.log(this.subSKUsequentCollectionGoods,'this.subSKUsequentCollectionGoods')
      if (!this.subSKUsequentCollectionGoods.length) {
        this.$message("您还未选择商品");
        return;
      }
      for(let i=0;i<this.subSKUsequentCollectionGoods.length;i++){
        if(this.subSKUsequentCollectionGoods[i].real_price == 0 || this.subSKUsequentCollectionGoods[i].real_price == null){
            this.$message('商品金额不能为0或空');
          }else{
            this.$confirm("确定此订单补收吗？点击确认后，会直接进行订单结算与扣款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })                                                                                                        
        .then(() => {
          this.$axios
            .post(`${apis.terminal_add_displays}/`, {
              order_id:this.$route.query.order_id,
              data:this.subSKUsequentCollectionGoods
              // hard_number: this.formData.machine_id,
              // order_token: this.formData.order_token,
              // data: this.subSKUsequentCollectionGoods,
              // seconds: this.formData.seconds,
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消成功",
              });
            });
        })
        .then(() => {
          this.goBack();
        });
          }

      }
    
    },
  },
  components: {
    BreadCrumb,
    SelectGoodsDialog,
  },
};
</script>

<style lang="scss" scoped>
.dropBtn {
  margin-right: 10px;
}

.bug-value {
  margin-right: 15px;
}

.btnFroup {
  text-align: right;
  padding: 0 15px 15px 15px;
}

.order-form {
  position: relative;
}

.order-status {
  position: absolute;
  right: 20px;
  top: 20px;

  &__label {
    font-size: 16px;
    margin-right: 15px;
    color: #666;
  }

  &__value {
    font-size: 16px;
  }

  &__value.error {
    color: #ff0000;
  }

  &__value.warning {
    color: #ff9933;
  }
}

.order-handle-dialog {
  &-title {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: bold;
  }

  &-row {
    padding: 8px 0;
  }

  &-row.center {
    text-align: center;
  }

  &-table {
    margin-bottom: 16px;
  }
}

.picture-dialog {
  text-align: center;
}

.picture-tab {
  margin-bottom: 15px;
}

.picture-box {
  display: flex;

  &-con {
    flex: 1;
  }

  &-con-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-con-img {
    text-align: center;

    canvas {
      margin-bottom: 15px;
    }
  }

  &-con + &-con {
    margin-left: 30px;
  }
}
.change-goods-con {
  text-align: left;
  padding: 0 0 12px 0;
}
.center-box {
  text-align: center;
}
.collection-goods-footer {
  text-align: center;
}
</style>
